import React from "react";

const MachineIdLogoSmall = () => {
  return (
    <svg width="35" height="34" viewBox="0 0 35 34" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.795898" width="34" height="34" rx="4" fill="white" />
      <path d="M13.1113 8.6001H21.3913C23.2633 8.6001 24.9113 8.9441 26.3353 9.6321C27.7753 10.3041 28.8873 11.2721 29.6713 12.5361C30.4713 13.8001 30.8713 15.2881 30.8713 17.0001C30.8713 18.7121 30.4713 20.2001 29.6713 21.4641C28.8873 22.7281 27.7753 23.7041 26.3353 24.3921C24.9113 25.0641 23.2633 25.4001 21.3913 25.4001H13.1113V8.6001ZM21.1513 20.9841C22.3673 20.9841 23.3353 20.6401 24.0553 19.9521C24.7913 19.2481 25.1593 18.2641 25.1593 17.0001C25.1593 15.7361 24.7913 14.7601 24.0553 14.0721C23.3353 13.3681 22.3673 13.0161 21.1513 13.0161H18.7753V20.9841H21.1513Z" fill="#1D1D1D" />
      <path d="M4.7207 8.6001H10.3847V25.4001H4.7207V8.6001Z" fill="#1D1D1D" />
    </svg>
  );
}

export default MachineIdLogoSmall;